import React from 'react';
import { MEDICAL_EXAM_CATEGORIES } from '../../../constants/medicalExamCategories';
import MedicalExamCatalogManager from '../medicalExams/MedicalExamCatalogManager';

/** Page Head Doctor — référentiel des radiographies. */
export default function HeadDoctorRadiographiesPage() {
  return <MedicalExamCatalogManager categoryId={MEDICAL_EXAM_CATEGORIES.RADIOGRAPHY.id} />;
}
